import { render } from "./index.vue?vue&type=template&id=4481844d&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=4481844d&lang=scss&scoped=true"

import exportComponent from "D:\\xampp\\htdocs\\JuHui\\ju-hui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4481844d"]])

export default __exports__